<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-form label-width="80px">
					<div class="form-items-wrapper">
						<el-form-item label="代理商">
							<el-select v-model="query.agentId" @change="agentChange" clearable filterable
								placeholder="请选择代理商" size="small" class="handle-input" style="width: 260px;">
								<el-option v-for="item in agents" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="企业">
							<el-select v-model="query.companyId" clearable filterable placeholder="请选择企业" size="small"
								class="handle-input" style="width: 260px;">
								<el-option v-for="item in companys" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="号码">
							<el-input size="small" v-model="query.phone" clearable filterable placeholder="请输入手机号码"
								style="width: 260px;"></el-input>
						</el-form-item>
						<el-form-item label="类型">
							<el-select size="small" v-model="query.type" clearable filterable placeholder="请选择类型"
								style="width: 260px;">
								<el-option v-for="item in typeList" :key="item.label" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="地市">
							<el-select size="small" v-model="query.city" clearable filterable placeholder="请选择地市"
								style="width: 260px;">
								<el-option v-for="item in cityList" :key="item.label" :label="item.city"
									:value="item.city"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="制式">
							<el-select size="small" v-model="query.standard" clearable filterable placeholder="请选择制式"
								style="width: 260px;">
								<el-option v-for="item in standardList2" :key="item.label" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="ICCID">
							<el-input size="small" v-model="query.iccid" clearable filterable placeholder="请输入ICCID"
								style="width: 260px;"></el-input>
						</el-form-item>
						<el-form-item label="IMSI">
							<el-input size="small" v-model="query.imsi" clearable filterable placeholder="请输入IMSI"
								style="width: 260px;"></el-input>
						</el-form-item>
						<el-form-item label="品牌">
							<el-select size="small" v-model="query.cardId" clearable filterable placeholder="请选择品牌"
								style="width: 260px;" @change="getSetMealList">
								<el-option v-for="item in cardTypeList" :key="item.label" :label="item.value"
									:value="item.label"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="套餐">
							<el-select size="small" v-model="query.setMealId" clearable filterable placeholder="请选择套餐"
								style="width: 260px;">
								<el-option v-for="item in setMealIdList" :key="item.label" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="批开">
							<el-select size="small" v-model="query.batchOpen" clearable filterable placeholder="是否批开"
								style="width: 260px;">
								<el-option v-for="item in activationList" :key="item.label" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="激活">
							<el-select size="small" v-model="query.activation" clearable filterable placeholder="是否激活"
								style="width: 260px;">
								<el-option v-for="item in activationList" :key="item.label" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="退卡">
							<el-select size="small" v-model="query.back" clearable filterable placeholder="是否已退回卡片"
								style="width: 260px;">
								<el-option v-for="item in activationList" :key="item.label" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="批次号">
							<el-input size="small" v-model="query.batchNum" clearable placeholder="请输入批次号"
								style="width: 260px;"></el-input>
						</el-form-item>
						<el-form-item label="操作人">
							<el-select size="small" v-model="query.operator" clearable filterable placeholder="请选择操作人"
								style="width: 260px;">
								<el-option v-for="item in operatorList" :key="item.label" :label="item.operator"
									:value="item.operator"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间">
							<el-date-picker v-model="timeArr" type="daterange" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime" size="small"
								style="width: 260px;"></el-date-picker>
						</el-form-item>
						<el-form-item label="">
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
								@click="getData">搜索</el-button>
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
								class="handle-del ml10" style="margin:0 0 6px 10px;"
								@click="getdownloadOutboundTemplate">
								下载模板
							</el-button>
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus"
								@click="getAddDelivery">出库上传</el-button>
							<el-button size="small" type="primary" :class="[theme]"
								@click="showFrequencyLimitingVisible">迪加批量限频</el-button>
							<el-button size="small" type="primary" :class="[theme]"
								@click="showreturnCard">退卡</el-button>
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
								@click="exportData">导出</el-button>
						</el-form-item>
					</div>
				</el-form>

			</div>
			<el-row :gutter="20" type="flex" class="row-bg">
				<el-col :span="24">
					<el-table :data="tableData" border class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe
						@selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agent" label="代理商" align="center" min-width="180"></el-table-column>
						<el-table-column prop="company" label="企业" align="center" min-width="180"></el-table-column>
						<el-table-column prop="cardType" label="运营商" align="center" width="100"></el-table-column>
						<el-table-column prop="standard" label="制式" align="center" width="80"></el-table-column>
						<el-table-column prop="phone" label="号码" align="center" width="120"></el-table-column>
						<el-table-column prop="iccid" label="ICCID" align="center" min-width="180"></el-table-column>
						<el-table-column prop="phoneStatus" label="号码状态" align="center"
							min-width="140"></el-table-column>
						<el-table-column prop="uid" label="批次号" align="center" width="96"></el-table-column>
						<el-table-column prop="setMeal" label="套餐" align="center" width="150">
							<template #default="scope">
								<el-tooltip placement="top">
									<template #content>
										<div style="max-width: 300px; white-space: pre-wrap;"
											v-for='item in scope.row.setMealList' :key="item">
											{{item.min}}分钟{{item.price}}元
										</div>
									</template>
									<span>{{scope.row.setMeal}}</span>
								</el-tooltip>
							</template>
						</el-table-column>

						<el-table-column prop="type" label="类型" align="center" width="80"></el-table-column>
						<el-table-column prop="back" label="退卡" align="center" width="80">
							<template #default="scope">
								<el-tag v-if="scope.row.back==true" type="danger">是</el-tag>
								<el-tag v-if="scope.row.back==false" type="success">否</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="出库时间" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="operator" label="操作人" align="center"></el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
		<el-dialog title="手动添加" v-model="addVisible" width="650px" :close-on-click-modal="false">
			<el-form :model="addForm" ref="addForm" label-width="120px">
				<el-form-item label="代理" prop="agent">
					<el-select v-model="addForm.agent" @change="companyChange" clearable filterable placeholder="请选择代理商"
						size="small" style="width: 100%;">
						<el-option v-for="item in agentsList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业" prop="companyId">
					<el-select v-model="addForm.companyId" clearable filterable placeholder="请选择企业" size="small"
						style="width: 100%;">
						<el-option v-for="item in companysList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="添加号码">
					<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
						v-model="addForm.phones"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="addVisibleClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAddReport">确定上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<express-detail-dialog v-if="dialogVisible" v-model="dialogVisible" :express-info="expressData"
			@close="handleClose" />
		<el-dialog title="上传添加" v-model="uploadVisible" width="650px" @close="uploadformClose">
			<el-form :model="uploadform" ref="addForm" label-width="120px">
				<el-form-item label="上传文件">
					<el-upload ref="upload" action="/api/SjtxCard/temporaryDelivery" :headers="token" :limit="1"
						:on-preview="handlePreview" :on-remove="handleRemove" :on-success="uploadSuccess"
						:auto-upload="false" :data="uploadform" :before-upload="beforeUpload">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="uploadformClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitUpload">确定上传</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog title="出库限频" v-model="frequencyLimitingVisible" width="450px" @close="frequencyLimitingClose">
			<el-form :model="frequencyLimitingForm" ref="frequencyLimitingForm" label-width="120px">
				<el-form-item label="制式">
					<el-select size="small" v-model="frequencyLimitingForm.standard" clearable filterable multiple
						placeholder="请选择制式" style="width: 260px;">
						<el-option v-for="item in standardList2" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="接通频次">
					<el-input size="small" v-model="frequencyLimitingForm.num" clearable placeholder="请输入限频次数"
						style="width: 260px;"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="frequencyLimitingClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="frequencyLimitingSet">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="退卡" v-model="returnCardVisible" width="450px" @close="returnCardClose">
			<el-form :model="returnCardForm" ref="returnCardForm" label-width="100px">
				<el-form-item label="号码">
					<el-input v-model="returnCardForm.phones" type="textarea" placeholder="请输入退卡号码" />
				</el-form-item>
				<el-form-item label="退卡">
					<el-switch v-model="returnCardForm.back" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="returnCardClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getReturnCard">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getReportNumberList,
		deleteReportNumber,
		getReportCompany,
		getReportAgent,
		downloadReportNumber
	} from '../../api/reportNumber.js';
	import {
		deliveryList,
		logisticsInquiry,
		setMealList,
		deliveryOperator,
		deliveryCity,
		downloadOutboundTemplate,
		temporaryDelivery,
		dxtLimitCall,
		deliveryDownload,
		returnCard
	} from '../../api/SjtxCard.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	import ExpressDetailDialog from '../../components/ExpressDetailDialog.vue'
	import {
		addReport,
		fetchCompanyByAgentId
	} from '../../api/companyIndex.js';
	import {
		fetchAgent
	} from '../../api/agentIndex';
	export default {
		name: 'outboundRecord',
		components: {
			ExpressDetailDialog
		},
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					userId: localStorage.getItem('user'),
					agentId: '',
					companyId: '',
					cardId: '',
					city: '',
					standard: '',
					setMealId: '',
					batchOpen: '',
					isReport: '',
					startTime: '',
					endTime: '',
					batchNum: '',
					operator: '',
					iccid: '',
					imsi: '',
					back: false,
					phone: '',
					activation: '', //激活
					pageIndex: 1,
					pageSize: 10,
				},

				timeArr: [],
				tableData: [],
				pageTotal: 0,
				multipleSelection: [],
				addForm: {
					phones: '',
				},
				addVisible: false,
				dialogVisible: false,
				expressData: [],
				agents: [],
				companys: [],
				standardList: [{
						value: '1',
						label: '联通',
					},
					{
						value: '2',
						label: '电信',
					},
					{
						value: '3',
						label: '移动',
					}
				],
				activationList: [{
						value: true,
						label: '是',
					},
					{
						value: false,
						label: '否',
					}
				],

				typeList: [{
						value: '1',
						label: '新增',
					},
					{
						value: '2',
						label: '换卡',
					},
					{
						value: '3',
						label: '补卡',
					}
				],
				operatorList: [],

				uploadVisible: false,
				uploadform: {},
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				frequencyLimitingVisible: false,
				frequencyLimitingForm: {
					standard: '',
					num: ''
				},
				standardList2: [{
						value: '联通',
						label: '联通',
					},
					{
						value: '电信',
						label: '电信',
					},
					{
						value: '移动',
						label: '移动',
					}
				],
				returnCardVisible: false,
				returnCardForm: {
					phones: '',
					back: false,
				},
			};
		},
		created() {
			fetchAgent(localStorage.getItem('user')).then(res => {
				//代理
				this.agents = res.data;
			});
			this.getData();
			this.getSetMealList();
			this.getDeliveryOperator();
			this.getDeliveryCity();
			this.getCardType();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			showreturnCard() {
				this.returnCardVisible = true;
				this.returnCardForm.phones = "";
				this.returnCardForm.back = false;
			},
			returnCardClose() {
				this.returnCardVisible = false;
			},
			getReturnCard() {
				let data = {
					phones: this.returnCardForm.phones,
					back: this.returnCardForm.back,
				}
				returnCard(data).then(res => {
					if (res?.code === 200) {
						this.returnCardVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//获取时间
			getTime() {
				if (Array.isArray(this.timeArr) && this.timeArr.length === 2) {
					this.query.startTime = this.toDateTimeStr(this.timeArr[0]);
					this.query.endTime = this.toDateTimeStr(this.timeArr[1]);
				} else {
					this.query.startTime = '';
					this.query.endTime = '';
					this.timeArr = [];
				}
			},
			toDateTimeStr(nS) {
				let date = new Date(nS);
				let YY = date.getFullYear() + '-';
				let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
				return YY + MM + DD;
			},
			//获取代理商
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				//代理商下拉
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},

			getData() {
				this.loading = true;
				deliveryList(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//品牌
			getCardType() {
				getCardType().then(res => {
					this.cardTypeList = res.data;
				})
			},
			//套餐
			getSetMealList() {
				this.query.setMealId = '';
				let data = {
					cardId: this.query.cardId,
				};
				setMealList(data).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//操作人
			getDeliveryOperator() {
				deliveryOperator().then(res => {
					if (res?.code === 200) {
						this.operatorList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//城市
			getDeliveryCity() {
				deliveryCity().then(res => {
					if (res?.code === 200) {
						this.cityList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//弹窗
			showExpressDialog(row) {
				this.dialogVisible = true;
				let data = {
					id: row.id,
				}
				logisticsInquiry(data).then(res => {
					if (res?.code === 200) {
						this.expressData = res.data;
						this.expressData.userData = row;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleClose() {
				console.log('弹窗已关闭')
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			//下一页
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			//下载磨板
			getdownloadOutboundTemplate() {
				downloadOutboundTemplate().then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '临时出库模板' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});

			},
			getAddDelivery() {
				this.uploadVisible = true;
			},
			uploadformClose() {
				this.uploadVisible = false;
			},

			handleRemove(file, fileList) {
				console.log(file, fileList, 'handleRemove');
			},
			handlePreview(file) {
				console.log(file, 'handlePreview');
			},
			uploadSuccess(success) {
				if (success?.code === 200) {
					this.uploadVisible = false;
					this.$message.success('上传成功');
				} else {
					this.$message.error(success.message);
				}

				this.$refs.upload.clearFiles();
				this.getData();
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			showFrequencyLimitingVisible() {
				this.frequencyLimitingVisible = true;
			},
			frequencyLimitingClose() {
				this.frequencyLimitingVisible = false;
			},
			frequencyLimitingSet() {
				let data = {
					standard: this.frequencyLimitingForm.standard.join(","),
					num: this.frequencyLimitingForm.num,
				};
				dxtLimitCall(data).then(res => {
					if (res?.code === 200) {
						this.frequencyLimitingForm.standard = '';
						this.frequencyLimitingForm.num = '';
						this.frequencyLimitingVisible = false;

					} else {
						this.$message.error(res.message);
					}
				});
			},
			exportData() {
				deliveryDownload(this.query).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '出库记录' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 50px;
	}

	/* a:hover{background: #66b1ff} */
	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.w_130 {
		width: 130px;
	}



	.form-items-wrapper {

		display: flex;

		flex-wrap: wrap;

		/* 允许子元素换行 */

		justify-content: flex-start;

		/* 水平对齐方式（可选） */

		align-items: center;



	}



	.form-items-wrapper .el-form-item {

		/* 根据需要调整 el-form-item 的样式 */

		flex: 0 0 auto;

		/* 不放大也不缩小，但会占据空间 */

		margin: 5px 10px 5px 0;

		display: flex;

		flex-direction: row;

		/* 如果使用 gap 属性，则不需要这个 */

	}



	.form-items-wrapper .el-form-item__label {

		/* 调整标签样式（可选） */

	}



	/deep/ .handle-box .el-form-item__content {

		margin-left: 0 !important;

	}



	/deep/ .handle-box .el-form-item__label {

		font-size: 14px !important;

	}
</style>